import { actFormFields } from '../../../containers/ActForm/constants';
import { selectSpecialty } from '../../../containers/User/selectors';
import { getStore } from '../../../reduxStore/configureStore';
import SpecialtyName from '../../../../shared/core/doctor/domain/SpecialtyName';
import Act, { ActCode } from '../../../../shared/domain/activity/act/model/Act';
import { codeIsInRole2 } from '../../../../shared/domain/activity/act/service/actCodeUtils';
import RAMQCodes, { TimedAttributeKey } from '../../../../shared/ramq/RamqCodes';

const NO_ERRORS = {};

const countsTowardRole2Limit = (code: ActCode, act: Act, userSpecialty: SpecialtyName) => {
  if (!codeIsInRole2(code, act, userSpecialty)) return false;

  const ramqCode = RAMQCodes.get(code.code);
  if (!ramqCode) return true;

  return RAMQCodes.getTimedAttribute<boolean>(ramqCode, TimedAttributeKey.isAddendum8, act.date) !== true;
};

const formatCodeList = (codes: string[]) => {
  if (codes.length <= 1) return codes.join('');

  const lastCode = codes[codes.length - 1];
  return `${codes.slice(0, -1).join(', ')} et ${lastCode}`;
};

export const atMostOneRole2CodeValidation = (act: Act) => {
  const userSpecialty = selectSpecialty()(getStore().getState());
  const role2Codes = (act.codes ?? []).filter((code) => countsTowardRole2Limit(code, act, userSpecialty));

  if (role2Codes.length <= 1) return NO_ERRORS;

  const listedCodes = formatCodeList(role2Codes.map(({ code }) => code));

  return {
    [actFormFields.codes]: {
      _error: `Les codes ${listedCodes} sont en rôle 2. Un seul code en rôle 2 peut être facturé par acte. SVP enlever les codes en surplus et envoyer.`
    }
  };
};

export default atMostOneRole2CodeValidation;
